import gql from 'graphql-tag';

const updateTemplateMutation = gql`
  mutation splashPageTemplateActions($templateId: String!, $action: TemplateActions!, $optionalParams: OptionalParams) {
    splashPageTemplateActions(templateId: $templateId, action: $action, optionalParams: $optionalParams) {
      splashTemplatesDescriptorId
      status
    }
}
`;

const updateTemplate = () => ({
  mutation: updateTemplateMutation,
  module: 'splash',
  buildVariables: ({ templateId, action, optionalParams

  }) => ({
    templateId,
    action,
    ...(optionalParams ? { optionalParams } : {})
  })
});

export default updateTemplate;